
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"53","viewBox":"0 0 69 53","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M24.658 16.5h20.625V33H24.658z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"3.867","d":"M11.248 37.254h49.5"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"5.156","d":"M11.248 9.796h47.438"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"3.867","d":"M11.248 43.442h49.5"}})])
          )
        }
      }
    